/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type BulkUpdatePhaseBaselineRolesInput = {
    projectId?: string | null | undefined;
    phaseBaselineRoles?: Array<BulkPhaseBaselineRolesInput | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type BulkPhaseBaselineRolesInput = {
    id?: string | null | undefined;
    projectId?: string | null | undefined;
    roleId?: string | null | undefined;
    phaseId?: string | null | undefined;
    deliverableId?: string | null | undefined;
    baselineMinutes?: number | null | undefined;
};
export type bulkUpdatePhaseBaselineRolesMutationVariables = {
    input: BulkUpdatePhaseBaselineRolesInput;
};
export type bulkUpdatePhaseBaselineRolesMutationResponse = {
    readonly bulkUpdatePhaseBaselineRoles: {
        readonly project: {
            readonly phaseBaselineRoles: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly globalPhaseId: string;
                        readonly deliverableId: number | null;
                        readonly role: {
                            readonly name: string | null;
                            readonly id: string;
                        } | null;
                        readonly baselineMinutes: number | null;
                        readonly financialNumbers: {
                            readonly baselineMinutes: number | null;
                            readonly baselineTimeAndExpenses: number | null;
                            readonly baselineRevenue: number | null;
                            readonly baselineCost: number | null;
                            readonly baselineProfit: number | null;
                            readonly baselineRatePerHour: number | null;
                            readonly baselineCostPerHour: number | null;
                        } | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type bulkUpdatePhaseBaselineRolesMutation = {
    readonly response: bulkUpdatePhaseBaselineRolesMutationResponse;
    readonly variables: bulkUpdatePhaseBaselineRolesMutationVariables;
};



/*
mutation bulkUpdatePhaseBaselineRolesMutation(
  $input: BulkUpdatePhaseBaselineRolesInput!
) {
  bulkUpdatePhaseBaselineRoles(input: $input) {
    project {
      phaseBaselineRoles(first: 1000000) {
        edges {
          node {
            id
            globalPhaseId
            deliverableId
            role {
              name
              id
            }
            baselineMinutes
            financialNumbers(convertToProjectCurrency: true) {
              baselineMinutes
              baselineTimeAndExpenses
              baselineRevenue
              baselineCost
              baselineProfit
              baselineRatePerHour
              baselineCostPerHour
            }
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "BulkUpdatePhaseBaselineRolesInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineMinutes",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PhaseBaselineRoleTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhaseBaselineRoleType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "globalPhaseId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deliverableId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "convertToProjectCurrency",
                "value": true
              }
            ],
            "concreteType": "FinancialNumbers",
            "kind": "LinkedField",
            "name": "financialNumbers",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineTimeAndExpenses",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineRevenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineProfit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineRatePerHour",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineCostPerHour",
                "storageKey": null
              }
            ],
            "storageKey": "financialNumbers(convertToProjectCurrency:true)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkUpdatePhaseBaselineRolesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BulkUpdatePhaseBaselineRolesPayload",
        "kind": "LinkedField",
        "name": "bulkUpdatePhaseBaselineRoles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "alias": "phaseBaselineRoles",
                "args": null,
                "concreteType": "PhaseBaselineRoleTypeConnection",
                "kind": "LinkedField",
                "name": "__Project_phaseBaselineRoles_connection",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkUpdatePhaseBaselineRolesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BulkUpdatePhaseBaselineRolesPayload",
        "kind": "LinkedField",
        "name": "bulkUpdatePhaseBaselineRoles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "PhaseBaselineRoleTypeConnection",
                "kind": "LinkedField",
                "name": "phaseBaselineRoles",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "phaseBaselineRoles(first:1000000)"
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_phaseBaselineRoles",
                "kind": "LinkedHandle",
                "name": "phaseBaselineRoles"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "bulkUpdatePhaseBaselineRoles",
            "project",
            "phaseBaselineRoles"
          ]
        }
      ]
    },
    "name": "bulkUpdatePhaseBaselineRolesMutation",
    "operationKind": "mutation",
    "text": "mutation bulkUpdatePhaseBaselineRolesMutation(\n  $input: BulkUpdatePhaseBaselineRolesInput!\n) {\n  bulkUpdatePhaseBaselineRoles(input: $input) {\n    project {\n      phaseBaselineRoles(first: 1000000) {\n        edges {\n          node {\n            id\n            globalPhaseId\n            deliverableId\n            role {\n              name\n              id\n            }\n            baselineMinutes\n            financialNumbers(convertToProjectCurrency: true) {\n              baselineMinutes\n              baselineTimeAndExpenses\n              baselineRevenue\n              baselineCost\n              baselineProfit\n              baselineRatePerHour\n              baselineCostPerHour\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '099ec716da6a1838d389e4851ed25275';
export default node;
